var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.205 9.807c-.008-1.366.61-2.396 1.86-3.155-.699-1.001-1.756-1.552-3.15-1.658-1.32-.104-2.764.769-3.293.769-.559 0-1.836-.733-2.842-.733-2.075.032-4.28 1.654-4.28 4.955 0 .975.178 1.983.535 3.02.476 1.366 2.195 4.713 3.987 4.659.938-.022 1.6-.665 2.82-.665 1.184 0 1.797.665 2.842.665 1.81-.026 3.363-3.069 3.816-4.439-2.425-1.143-2.295-3.348-2.295-3.418M11.1 3.697c1.015-1.205.923-2.302.893-2.697-.897.052-1.935.61-2.526 1.298-.65.737-1.033 1.648-.951 2.676.97.074 1.855-.425 2.584-1.276z"
  })));
};
export default SvgApple;